import React, { useCallback, useState, useEffect } from 'react';
import { LogoutOutlined, SettingOutlined, UserOutlined, DownOutlined,BgColorsOutlined } from '@ant-design/icons';
import { history, useModel } from '@umijs/max';
import type { Settings as LayoutSettings } from '@ant-design/pro-components';
import { Spin } from 'antd';
import type { MenuProps } from 'antd';
import { message } from 'antd';
import { createStyles } from 'antd-style';
import { stringify } from 'querystring';
import { flushSync } from 'react-dom';
import { RESPONSE_CODES, USER_KEY, ACCESS_TOKEN_KEY, EXPIRES_TIME_KEY, REFRESH_TOKEN_KEY, DATASET_FILTER_KEY, TASK_FILTER_KEY } from '@/utils/constants';
import MyIcon from '@/utils/iconfont';
import HeaderDropdown from '../HeaderDropdown';
import Settings, { themes } from '../../../config/defaultSettings';
import { logout } from '@/services/api/user';

// import UpdatePassword from './UpdatePassword';

export type GlobalHeaderRightProps = {
  menu?: boolean;
  children?: React.ReactNode;
};

export const AvatarName = () => {
  const { initialState } = useModel('@@initialState');
  const { currentUser } = initialState || {};
  return <span className="anticon">{currentUser?.displayName}</span>;
};

const useStyles = createStyles(({ token }) => {
  return {
    action: {
      display: 'flex',
      height: '48px',
      marginLeft: 'auto',
      overflow: 'hidden',
      alignItems: 'center',
      padding: '0 8px',
      cursor: 'pointer',
      borderRadius: token.borderRadius,
      '&:hover': {
        backgroundColor: token.colorBgTextHover,
      },
    },
  };
});

export const AvatarDropdown: React.FC<GlobalHeaderRightProps> = ({ menu, children }) => {
  const [visible, setVisible] = useState(false);
  /**
   * 退出登录，并且将当前的 url 保存
   */
  const loginOut = async () => {
    const result = await logout();
    if (result?.code != RESPONSE_CODES.SUCCESS) {
      message.error("登出失败，重新尝试。");
      return;
    }
    /** 此方法会跳转到 redirect 参数所在的位置 */
    // const redirect = urlParams.get('redirect');
    // if (window.location.pathname !== '/user/login' && !redirect) {
    // 1. 取出本地 user 中要保留的字段
    const stored = localStorage.getItem(USER_KEY);
    let keep: { id: number; currentTenantId: number } | null = null;
    if (stored) {
      try {
        const u = JSON.parse(stored);
        keep = { id: u.id, currentTenantId: u.currentTenantId };
      } catch { }
    }
    // 清理本地存储
    // 清除 sessionStorage 中的 token 字段
    sessionStorage.removeItem(ACCESS_TOKEN_KEY);
    sessionStorage.removeItem(EXPIRES_TIME_KEY);
    sessionStorage.removeItem(REFRESH_TOKEN_KEY);

    // 清除 localStorage 中的其他字段
    localStorage.removeItem(DATASET_FILTER_KEY);
    localStorage.removeItem(TASK_FILTER_KEY);
    localStorage.removeItem(USER_KEY);
    // sessionStorage.clear();
    // localStorage.clear();
    // 3. 只写回 id 和 currentTenantId：上次选择租户已改为后端记录，前端不再保存
    // if (keep) {
    //   localStorage.setItem(USER_KEY, JSON.stringify(keep));
    // }

    history.replace({
      pathname: '/user/login',
      // search: stringify({
      //   // redirect: pathname + search,
      //   redirect: window.location.href,
      // }),
    });
  }

  const { styles } = useStyles();

  const { initialState, setInitialState } = useModel('@@initialState');
  const { currentUser } = initialState;

  // const allRoles = currentUser?.teamList?.reduce((acc: string[], team) => {
  //   if (Array.isArray(team.roles)) {
  //     return acc.concat(team.roles);
  //   }
  //   return acc;
  // }, []);

  // 去重，确保角色数组中没有重复的角色
  // const uniqueALlRoles = Array.from(new Set(allRoles));

  const onMenuClick: MenuProps['onClick'] = (event) => {
    const { key } = event;
    if (key === 'logout') {
      flushSync(() => {
        setInitialState((s) => ({ ...s, currentUser: undefined }));
      });
      loginOut();
      return;

    }

    // 切换主题
    if (key.startsWith('theme-')) {
      const themeName = key.replace('theme-', '');
      const theme = themes[themeName];
      if (theme) {
        // 持久化到 localStorage，刷新后仍保留
        localStorage.setItem('app-theme', themeName);
        // 应用 CSS 变量（顶部导航、侧边栏等自定义颜色）
        const root = document.documentElement;
        Object.entries(theme.cssVars || {}).forEach(([k, v]) =>
          root.style.setProperty(k, v)
        );
        setInitialState((s) => ({
          ...s,
          settings: theme as Partial<LayoutSettings>,
        }));
        message.success(`已切换主题`);
      }
      return;
    }

    if (key === 'resetPassword') {
      setVisible(true);
    }
    // 新窗口跳转到个人中心
    if (key === 'personalcenter') {
      const fullPath = `${window.location.origin}${Settings.base}#/personalcenter`;
      window.open(fullPath, '_blank');
      // history.push('/account/settings');
    }
    // if (key === 'admin') {
    //   // window.open('/admin/tenantview', '_blank'); //系统管理
    //   window.open('/admin/user', '_blank'); //系统管理默认跳转到用户，待租户管理完成后，跳转到租户管理
    // }
  };

  const loading = (
    <span className={styles.action}>
      <Spin
        size="small"
        style={{
          marginLeft: 8,
          marginRight: 8,
        }}
      />
    </span>
  );

  if (!initialState) {
    return loading;
  }



  if (!currentUser || !currentUser.userName) {
    return loading;
  }

  //在入口页配置menu值来设置是否显示个人中心和个人设置
  const menuItems = [
    {
      key: 'personalcenter',
      icon: <UserOutlined />,
      label: '个人中心',
    },
    // 仅当 uniqueALlRoles 包含 'system' 时显示 "系统管理"
    // ...(uniqueALlRoles?.some((role) => ['system', 'admin', 'tenant_admin'].includes(role))
    //   ? [
    //     {
    //       key: 'admin',
    //       icon: <SettingOutlined />,
    //       label: '系统管理',
    //     },
    //   ]
    //   : []),
    // {
    //   key: 'resetPassword',
    //   icon: <MyIcon type="icon-bi" />,
    //   label: '修改密码',
    // },
    {
      key: 'theme',
      icon: <BgColorsOutlined />,
      label: '切换主题',
      children: [
        {
          key: 'theme-businessblue',
          label: '商务蓝',
        },
        {
          key: 'theme-grayblue',
          label: '拂晓蓝',
        },

      ],
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
    },
  ];


  const handleModal = () => {
    setVisible(!visible);
    history.replace({
      pathname: '/user/login',
    });
  };
  const handleCloseModal = () => {
    setVisible(false);
  }

  return (
    <>
      <HeaderDropdown
        menu={{
          selectedKeys: [],
          onClick: onMenuClick,
          items: menuItems,
        }}
      >
        {children}
      </HeaderDropdown>
      {/* <UpdatePassword visible={visible} initialState={initialState} onOk={() => handleModal()} onCancel={()=>{handleCloseModal()}} /> */}
    </>
  );
};
